import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const Base = {
  state: {
    lang: "en",
    tb: undefined,
    newsletter: false,
  },
  getters: {
    lang: (state) => state.lang,
    textbooklet: (state) => state.tb,
    newsletter: (state) => state.newsletter,
  },
  mutations: {
    set_lang(state, lang) {
      state.lang = lang;
    },
    set_newsletter(state, newsletter) {
      state.newsletter = newsletter;
    },
    set_tb(state, tb) {
      state.tb = tb;
    },
  },
};

export default new Vuex.Store({
  modules: {
    base: Base,
  },
});
